<template>
  <div class="show-tickets">
    <div @click="setStep(3)" class="show-ticket-text">
      <div>Total:</div>
      <div>R$ {{ String(Number(Number(total) + Number(serviceFee)).toFixed(2)).replace('.', ',').toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
      <div style="margin-left: 10px; text-transform: capitalize">{{ getTicketsTypes }}</div>
      <i v-if="step > 3" class="fas fa-angle-down"></i>
    </div>
    <form v-if="step === 3" @submit.prevent class="form">
      <div v-for="(ticket, index) in groupedTickets" :key="ticket.seat" class="show-ticket">
        <!-- SEATS -->
        <template v-if="!ticket.table">
          <div>
            <b>{{ ticket.section.replace(/_/g, " ") }}</b> - {{ ticket.seat }}
          </div>
          <select v-if="!ticket.special && !withSection" v-model="ticket.showPrice" :class="{ error : error.includes(index) }">
            <option :value="null">Selecione o tipo</option>
            <option
              v-for="price in pricesFiltered.filter(x => !x.special)"
              v-show="price.active"
              :disabled="disabledOptions(index, price)"
              :key="price.id"
              :value="price"
              style="text-transform: capitalize"
            >
              {{ `${price.ticketType} ${disabledOptions(index, price) ? 'ESGOTADO*' : ''}` }}
            </option>
          </select>
          <select v-else-if="!ticket.special && withSection" v-model="ticket.showPrice" :class="{ error : error.includes(index) }">
            <option :value="null">Selecione o tipo</option>
            <option
              v-for="price in pricesFiltered.filter(x => !x.special && x.section === ticket.section)"
              :disabled="disabledOptions(index, price)"
              :key="price.id"
              :value="price"
              style="text-transform: capitalize"
            >
              {{ `${price.ticketType} ${ disabledOptions(index, price) ? " ESGOTADO*" : "" }` }}
            </option>
          </select>
          <select v-else v-model="ticket.showPrice">
            <option v-for="price in pricesFiltered.filter(x => x.special)" :key="price.id" :value="price" style="text-transform: capitalize">{{ price.ticketType }}</option>
          </select>
          <div :style="`visibility: ${ ticket.showPrice ? 'visible' : 'hidden' }`">
            R$ {{ ticket.showPrice ? ticket.showPrice.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '-' }}
          </div>
          <div v-if="error.includes(index)" class="hint">Selecione o tipo de ingresso</div>
        </template>
        <!-- TABLES -->
        <template v-else>
          <div v-if="withSection">
            <b>{{ ticket.section ? ticket.section.replace(/_/g, " ") : '' }}</b> - {{ ticket.seat.split('-')[0] }}
          </div>
          <div v-else>
            {{ ticket.seat.split('-')[0] }}
          </div>
          <select v-model="ticket.showPrice">
            <option
              :key="ticket.showPrice.id"
              :value="ticket.showPrice"
              style="text-transform: capitalize"
            >
              {{ ticket.showPrice.ticketType }}
            </option>
          </select>
          <div :style="`visibility: ${ ticket.showPrice ? 'visible' : 'hidden' }`">
            R$ {{ ticket.showPrice ? (ticket.showPrice.tablePrice).toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '-' }}
          </div>
        </template>
      </div>
      <div style="
        width: 100%;
        margin: 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      ">
        <div style="font-size: 0.7em" v-if="meiaSoldOut">*O número de ingressos meia-entrada vendidos para esse espetáculo já atingiu a cota de 40% do total de ingressos disponíveis para venda ao público em geral, conforme Decreto Federal nº 8.537 e Leis Federais n° 12.933 e n° 12.852.</div>
        <div>Taxa de serviço: R$ {{ serviceFee.replace('.', ',').toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
      </div>
    </form>
    <div v-if="step === 3" class="show-ticket-total">
      <button @click="confirm" type="button" class="button-next"><span>Continuar</span><i class="fas fa-angle-right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'showTicket',
  props: ['step', 'setStep', 'withoutStage', 'withSection', 'tickets', 'prices', 'finishTickets', 'payment'],
  data () {
    return {
      tempTickets: [],
      error: []
    }
  },
  computed: {
    meiaSectionId () {
      return this.prices.filter(x => x.ticketType.toUpperCase().startsWith('MEIA') && x.section === this.tempTickets[0].section)[0]
    },
    meia () {
      return this.prices.filter(x => x.ticketType.toUpperCase().startsWith('MEIA')).reduce((a, c) => {
        a.amount += c.amount
        a.amountsold += c.amountsold
        return a
      }, {
        amount: 0,
        amountsold: 0
      })
    },
    meiaSoldOut () {
      if (this.meia.amountsold === 0) return false
      if (this.withSection && this.tempTickets.filter(x => (x.showPrice ? x.showPrice.id : null) === this.meiaSectionId.id).length >= (this.meia.amount - this.meia.amountsold)) return true
      if (this.tempTickets.filter(x => x.showPrice && x.showPrice.ticketType.toUpperCase().startsWith('MEIA')).length >= (this.meia.amount - this.meia.amountsold)) return true
      return this.meia.amount - this.meia.amountsold === 0
    },
    getTicketsTypes () {
      if (this.tempTickets.length === 0) {
        return null
      } else {
        const types = this.tempTickets.reduce((accumulated, current, idx, array) => {
          const found = accumulated.find(x => current.showPrice && x.type === current.showPrice.ticketType)
          if (current.table) {
            if (!found) {
              accumulated.push({
                type: current.showPrice.ticketType,
                lote: current.showPrice.lote,
                count: array.filter(x => x.table === current.table).length / current.table
              })
            }
          } else if (found) {
            found.count += 1
          } else {
            if (current.showPrice) accumulated.push({ type: current.showPrice.ticketType, count: 1 })
          }
          return accumulated
        }, [])

        if (types) {
          let aux = ''
          types.forEach((x, i) => {
            aux += x.count + ' ' + x.type + ', '
          })
          aux = aux ? '(' + aux.substring(0, aux.length - 2) + ')' : null
          return aux
        } else {
          return null
        }
      }
    },
    total () {
      return this.tempTickets.length === 0 ? 0
        : this.tempTickets.map(x => x.showPrice ? x.showPrice.price : 0).reduce((acc, cur) => acc + cur)
    },
    serviceFee () {
      return Number(this.total * (this.payment ? this.payment.commission / 100 : 1)).toFixed(2)
    },
    pricesFiltered () {
      return this.prices.filter(x => x.ticketType.substr(0, 5) !== 'Mesa ')
    },
    groupedTickets () {
      return this.tempTickets.reduce((acc, cur) => {
        if (!cur.table) acc.push(cur)
        else if (!!cur.table && !acc.find(x => x.seat.split('-')[0] === cur.seat.split('-')[0])) acc.push(cur)
        return acc
      }, [])
    }
  },
  watch: {
    step (value, oldValue) {
      if (value === 3 && value > oldValue && !this.withoutStage) {
        if (JSON.stringify(this.tempTickets.map(x => x.seat)) !== JSON.stringify(this.tickets.map(x => x.seat))) {
          const tables = this.prices.filter(x => x.ticketType.substr(0, 5) === 'Mesa ').map(x => ({ seats: Number(x.ticketType.split(' ')[1]), price: x }))
          const tickets = this.tickets.map((x, i, array) => {
            const element = document.querySelector(`#stage #${x.seat}`)
            if (element.parentElement.parentElement.getAttribute('data-name') === 'Table') {
              const seats = Array.from(element.parentElement.parentElement.children).filter(y => y.id.substr(0, 7) === 'Assento')
              const selected = array.filter(y => y.seat.split('-')[0] === x.seat.split('-')[0])
              if (seats.length === selected.length) {
                const table = tables.find(t => t.price.section === x.section && t.seats === selected.length)
                if (table) {
                  x.table = table.seats
                  x.showPrice = table.price
                }
              }
            }
            return x
          })
          this.tempTickets = tickets
        }
      }
    }
  },
  methods: {
    disabledOptions (index, p) {
      if (!p) return false
      // Disable invitation when used
      if (p.ticketType.startsWith('Convite') && p.amount) {
        return this.tempTickets.filter(x => x.showPrice && x.showPrice.id === p.id).length >= p.amount
      }
      if (this.withSection) {
        const meiaSection = this.prices.filter(x => x.ticketType.toUpperCase().startsWith('MEIA') && x.section === p.section)[0]
        const result =
          String(p ? p.ticketType : '').toUpperCase().startsWith('MEIA') &&
          !((this.tempTickets[index].showPrice ? this.tempTickets[index].showPrice.id : null) === meiaSection.id) &&
          this.tempTickets.filter(x => (x.showPrice ? x.showPrice.id : null) === meiaSection.id).length >= (this.meia.amount - this.meia.amountsold)

        return result
      } else {
        const meiaSection = this.prices.filter(x => x.ticketType.toUpperCase().startsWith('MEIA'))[0]
        const result =
          String(p ? p.ticketType : '').toUpperCase().startsWith('MEIA') &&
          !((this.tempTickets[index].showPrice ? this.tempTickets[index].showPrice.id : null) === meiaSection.id) &&
          this.tempTickets.filter(x => (x.showPrice ? x.showPrice.id : null) === meiaSection.id).length >= (this.meia.amount - this.meia.amountsold)
        return result
      }
    },
    confirm () {
      this.error = []
      this.tempTickets.forEach((x, i) => {
        if (!x.showPrice) this.error.push(i)
      })
      if (this.error.length === 0) {
        this.finishTickets(this.tempTickets, Number(Number(this.total) + Number(this.serviceFee)).toFixed(2))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.show-tickets {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
  .show-ticket-text {
    display: flex;
    align-items: center;
    width: 100%;
    color: #333;
    font-size: 1em;
    font-weight: 300;
    div:nth-child(2) {
      color: $primary-color;
      font-size: 1.1em;
      font-weight: 500;
      margin-left: 10px;
    }
    i {
      flex: 1;
      text-align: right;
      cursor: pointer;
      font-size: 1.6em;
      color: #999;
    }
  }

  form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
  }

  .show-ticket {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 5px 0;
    select {
      flex: 1;
      margin: 0 10px;
    }
    div:nth-child(1) {
      height: 34px;
      border-radius: 5px;
      border-top: 1px solid $primary-color;
      border-bottom: 1px solid $primary-color;
      border-right: 1px solid $primary-color;
      border-left: 10px solid $primary-color;
      color: $primary-color;
      font-weight: 500;
      line-height: 32px;
      padding: 0 7px;
    }
    div:nth-child(3) {
      height: 34px;
      line-height: 32px;
      color: $primary-color;
      text-align: right;
      width: 100px;
      border: 1px solid $primary-color;
      border-radius: 5px;
      padding: 0 7px;
    }
    .hint {
      width: 100%;
    }
  }
  .show-ticket-total {
    width: 100%;
    margin-top: 10px;
  }
}

@media screen and (min-width: $desktop-width) {

  .show-ticket {
    width: 45% !important;
  }

}
</style>
